module.exports = __webpack_public_path__ + "static/media/footer.2d418fb7.png";